import { useState } from 'react';
import axios from 'axios';

export default function TestPolicyCreation() {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const createPolicy = async () => {
    setLoading(true);
    setError(null);
    setResult(null);

    try {
      // POST directly to production backend
      const response = await axios.post(
        'https://enact-dataspace.iti.gr/api/v1/data-exchange/provider/policy',
        {
          "policyId": "local-test-policy-from-simple-component-" + Date.now(),
          "permissions": [{"action": "USE", "target": "*"}],
          "providerUrl": "http://dev.ithaca.ece.uowm.gr:11002",
          "consumerUrl": "http://enact-dataspace.iti.gr:22002",
          "providerDspUrl": "http://dev.ithaca.ece.uowm.gr:11003/api/dsp",
          "consumerDspUrl": "http://enact-dataspace.iti.gr/edc-consumer/api/dsp",
          "apiKey": "ApiKeyDefaultValue"
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'X-Api-Key': 'ApiKeyDefaultValue'
          }
        }
      );
      
      setResult(response.data);
    } catch (err) {
      setError(err.response?.data || err.message);
      console.error('Full error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-4">Test Policy Creation</h1>
      <p className="text-gray-400 mb-4">Posting to: https://enact-dataspace.iti.gr/api/v1</p>
      
      <button
        onClick={createPolicy}
        disabled={loading}
        className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg disabled:opacity-50"
      >
        {loading ? 'Creating...' : 'Create Policy'}
      </button>

      {result && (
        <div className="mt-6 p-4 bg-green-900/20 border border-green-700 rounded-lg">
          <h2 className="text-lg font-semibold text-green-400 mb-2">✅ Success!</h2>
          <pre className="text-sm overflow-auto">{JSON.stringify(result, null, 2)}</pre>
        </div>
      )}

      {error && (
        <div className="mt-6 p-4 bg-red-900/20 border border-red-700 rounded-lg">
          <h2 className="text-lg font-semibold text-red-400 mb-2">❌ Error</h2>
          <pre className="text-sm overflow-auto">{JSON.stringify(error, null, 2)}</pre>
        </div>
      )}
    </div>
  );
}
